import { render, staticRenderFns } from "./summary-cards.vue?vue&type=template&id=caff3b18"
import script from "./summary-cards.vue?vue&type=script&lang=js"
export * from "./summary-cards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports